import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';

import { MdOutlineWebhook, MdContentCopy } from 'react-icons/md';
import NodeCardShell from '../Components/NodeCardShell';
import { useNodeTheme } from '../Components/NodeTheme';

const WEBHOOK_NODE_COLOR = '#FC6530';

const WebHook = ({ data, isConnectable, id, selected }) => {
  const [copied, setCopied] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const theme = useNodeTheme();

  useSyncNodeInternals(id, `${data.saved}~${data.first}`);

  return (
    <NodeCardShell
      icon={MdOutlineWebhook}
      color={WEBHOOK_NODE_COLOR}
      typeName="WebHook"
      title={data.title ?? 'WebHook'}
      summary={data.status_format_property ? `Espera evento · ${data.status_format_property}` : 'Espera evento'}
      trigger={data.user_response}
      error={data?.error}
      selected={selected}
      handles={
        <>
          {data.saved && (
            <Handle
              type="target"
              position={Position.Top}
              isConnectable={isConnectable}
              id={`target-${id}`}
              style={{ backgroundColor: WEBHOOK_NODE_COLOR }}
            />
          )}
          {data.saved && (
            <Handle
              type="source"
              position={Position.Bottom}
              id={`source-${id}`}
              isConnectable={isConnectable}
              style={{ backgroundColor: WEBHOOK_NODE_COLOR }}
            />
          )}
        </>
      }
    >
      {data.url && (
        <div
          className="d-flex align-items-center"
          style={{
            gap: '6px',
            padding: '0 12px 12px 12px',
            marginTop: '-4px',
          }}
        >
          <span
            style={{
              fontSize: '10px',
              color: '#8A96A5',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1,
              minWidth: 0,
            }}
            title={data.url}
          >
            {data.url}
          </span>
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <MdContentCopy
              style={{
                cursor: 'pointer',
                fontSize: '13px',
                color: theme.textSecondary,
                flexShrink: 0,
              }}
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              onClick={e => {
                e.stopPropagation();
                navigator.clipboard.writeText(data.url);
                setCopied(true);
                setTimeout(() => setCopied(false), 1200);
              }}
            />
            {(showTooltip || copied) && (
              <div
                style={{
                  position: 'absolute',
                  bottom: '20px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#222',
                  color: '#fff',
                  padding: '4px 12px',
                  borderRadius: 6,
                  fontSize: 11,
                  whiteSpace: 'nowrap',
                  pointerEvents: 'none',
                  opacity: copied ? 1 : 0.85,
                  transition: 'opacity 0.2s',
                  zIndex: 10000,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                }}
              >
                {copied ? '¡Copiado!' : 'Copiar'}
              </div>
            )}
          </div>
        </div>
      )}
    </NodeCardShell>
  );
};

export default React.memo(WebHook);
